import React from "react";
import { css } from "@emotion/core";
import SyncLoader from "react-spinners/SyncLoader";
import { Dimmer } from 'semantic-ui-react';

// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
  display: block;
  margin: 2 auto;
  border-color: #F8B739;
  padding-bottom: 1em;
`;

const Loader = ({ loading }) => {
  return (
    <div id="loader">
      <Dimmer active={loading} page>
        <div className="sweet-loading">
          <SyncLoader
            css={override}
            size={15}
            color={"#F8B739"}
            loading={loading}
          />
        </div>
        <div >Loading ...</div>
      </Dimmer>
    </div>
  );
}

export default Loader;
